import React from "react";
import PropTypes from "prop-types";
import { hideModal } from "@actions";
import { connect } from "react-redux";
import Form from "@components/form";

const SingleFooterSponsor = (props) => {
  const [state, setState] = React.useState({ item: props.item });

  return (
    <div className="form-container single-sponsor">
      <h2>{`${
        props.mode == "create" ? "Create Footer Sponsor" : "Edit Footer Sponsor"
      }`}</h2>
      <Form
        formName="footerSponsors"
        componentName="clientPanel"
        value={state.item}
        onSubmit={(data) => {
          if (Object.keys(data.errors).length) return false;
          if (
            !state.item.clientFooterSponsorImage?.length &&
            !data.value.clientFooterSponsorImage.length &&
            (props.item.clientFooterSponsorImage || [])[0]
          ) {
            data.value.clientFooterSponsorImage = [
              props.item.clientFooterSponsorImage[0].id,
            ];
          } else if (!data.value.clientFooterSponsorImage.length) {
            delete data.value.clientFooterSponsorImage;
          }
          props.onSave(data.value);
        }}
        onCancel={() => {
          props.hideModal();
        }}
        onChange={(data) => {
          if (data.key === "clientFooterSponsorImage") {
            setState({ item: { ...state.item, clientFooterSponsorImage: [] } });
          }
        }}
      />
    </div>
  );
};

SingleFooterSponsor.propTypes = {
  eventId: PropTypes.string.isRequired,
  hideModal: PropTypes.func,
  onSave: PropTypes.func,
  item: PropTypes.object,
  mode: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    eventId: state.page.params.eventId,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    hideModal: () => {
      dispatch(hideModal());
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleFooterSponsor);
